module.exports = __webpack_public_path__ + "static/media/wall-of-flowers.ad904d18.jpg";